import Vue from 'vue'
import ToastComponent from './Toast.vue'
let instance

let showing = false

let ToastConstructor = Vue.extend(ToastComponent)

let initInstance = () => {
  instance = new ToastConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(instance.$el)
}

let Toast = (content, duration = 1500) => {

  if (!showing) {
    showing = true
    initInstance()
    instance.is_show = true
    instance.content = content
    instance.duration = duration

    setTimeout(() => {
      showing = false
      instance.is_show = false
    }, instance.duration)
  }
}
export default Toast